const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const USER_ID = "uid";
const ACCOUNT_ID = "account";
const INITIALS = "initials";
const NAME = "name";
const FNAME = "firstName";
const FULLMENU = "fullmenu";
const PROJECT = "project";
const GLOBAL_MESSAGE = "global_message";
const TABLE_SORTING = "table_sorting";
const TABLE_HEADING_VISIBILITY = "table_heading_visibility";
const VIEWS_SELECTED = "views_selected";
const HIDES = "hide_items";
const DASHBOARD_VIEW = "dashboard_view";
const ADMIN_USER = "admin_user";
const BRAND = "brand";
const WELCOME = "welcome";
const IS_AMBER = "is_amber";
const BRAND_CONNECT_RESUME = "brand_connect_resume";

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
	getFullMenu() {
		if (localStorage.getItem(FULLMENU) !== null) return localStorage.getItem(FULLMENU);
		return true;
	},

	getCheckLogin() {
		return sessionStorage.getItem("checkedLogin");
	},

	getExtraInfo() {
		return JSON.parse(localStorage.getItem("extraInfo"));
	},

	getToken() {
		return localStorage.getItem(TOKEN_KEY);
	},

	getIsAmber() {
		return localStorage.getItem(IS_AMBER);
	},

	getBrand() {
		return localStorage.getItem(BRAND);
	},

	getWelcomeMessage() {
		return sessionStorage.getItem(WELCOME);
	},

	getAdminUser() {
		return localStorage.getItem(ADMIN_USER);
	},


	getViewsSelected() {
		let r = localStorage.getItem(VIEWS_SELECTED);
		if (r) {
			r = JSON.parse(r);
			return typeof r !== "object" || typeof r.val !== "object" ? {} : r.val;
		}
		return {};
	},

	getTableSorting() {
		let r = localStorage.getItem(TABLE_SORTING);
		if (r) {
			return JSON.parse(r).val;
		}
		return {};
	},

	getTableHeadingVisibility() {
		let r = localStorage.getItem(TABLE_HEADING_VISIBILITY);
		if (r) {
			return JSON.parse(r).val;
		}
		return {};
	},

	getId() {
		return localStorage.getItem(USER_ID);
	},

	getAccountId() {
		return localStorage.getItem(ACCOUNT_ID);
	},

	getInitials() {
		return localStorage.getItem(INITIALS);
	},

	getName() {
		return localStorage.getItem(NAME);
	},

	getFirstName() {
		return localStorage.getItem(FNAME);
	},

	getHide(key) {
		let r = localStorage.getItem(HIDES);
		if (r) {
			r = JSON.parse(r);
			return key ? !!r[key] : r;
		}
		return key ? false : {};
	},

	getGlobalMessage() {
		let gm = sessionStorage.getItem(GLOBAL_MESSAGE);
		if (gm) {
			return JSON.parse(gm);
		}
		return { message: "", colour: "red" };
	},

	getBrandConnectResume() {
		let resume = sessionStorage.getItem(BRAND_CONNECT_RESUME);
		if (!resume) return null;
		try {
			return JSON.parse(resume);
		} catch (error) {
			sessionStorage.removeItem(BRAND_CONNECT_RESUME);
			return null;
		}
	},

	saveId(id) {
		localStorage.setItem(USER_ID, id);
	},

	saveBrand(brand) {
		localStorage.setItem(BRAND, brand);
	},

	saveGlobalMessage(info) {
		sessionStorage.setItem(GLOBAL_MESSAGE, JSON.stringify(info));
	},

	saveBrandConnectResume(info) {
		sessionStorage.setItem(BRAND_CONNECT_RESUME, JSON.stringify(info));
	},

	saveCheckLogin() {
		sessionStorage.setItem("checkedLogin", true);
	},

	saveExtraInfo(info) {
		localStorage.setItem("extraInfo", JSON.stringify(info));
	},

	saveIsAmber(isAmber) {
		localStorage.setItem(IS_AMBER, isAmber);
	},

	saveDashboardView(info) {
		localStorage.setItem(DASHBOARD_VIEW, info);
	},

	saveWelcomeMessage(info) {
		sessionStorage.setItem(WELCOME, info);
	},

	saveAdminUser(user) {
		localStorage.setItem(ADMIN_USER, user);
	},


	saveViewsSelected(info) {
		localStorage.setItem(VIEWS_SELECTED, JSON.stringify({ val: info }));
	},

	saveHide(key, val) {
		let r = TokenService.getHide();
		r[key] = val;
		localStorage.setItem(HIDES, JSON.stringify(r));
	},

	saveTableSorting(info) {
		localStorage.setItem(TABLE_SORTING, JSON.stringify({ val: info }));
	},

	saveTableHeadingVisibility(info) {
		localStorage.setItem(TABLE_HEADING_VISIBILITY, JSON.stringify({ val: info }));
	},

	saveAccountId(id) {
		localStorage.setItem(ACCOUNT_ID, id);
	},

	saveInitials(init) {
		localStorage.setItem(INITIALS, init);
	},

	saveName(init) {
		localStorage.setItem(NAME, init);
	},

	saveFirstName(init) {
		localStorage.setItem(FNAME, init);
	},

	saveProject(projectId) {
		projectId === null ? projectId : projectId.toString();
		sessionStorage.setItem(PROJECT, projectId);
	},

	saveToken(accessToken) {
		localStorage.setItem(TOKEN_KEY, accessToken);
	},

	saveFullMenu(showFullMenu) {
		localStorage.setItem(FULLMENU, showFullMenu);
	},

	removeAdminUser() {
		localStorage.removeItem(ADMIN_USER);
	},

	removeToken() {
		localStorage.removeItem(TOKEN_KEY);
	},

	removeBrand() {
		localStorage.removeItem(BRAND);
	},

	removeInitials() {
		localStorage.removeItem(INITIALS);
	},

	removeGlobalMessage() {
		sessionStorage.removeItem(GLOBAL_MESSAGE);
	},

	removeBrandConnectResume() {
		sessionStorage.removeItem(BRAND_CONNECT_RESUME);
	},

	removeName() {
		localStorage.removeItem(NAME);
	},

	removeFirstName() {
		localStorage.removeItem(FNAME);
	},

	removeProject() {
		sessionStorage.removeItem(PROJECT);
	},

	removeCheckLogin() {
		sessionStorage.removeItem("checkedLogin");
	},

	removeExtraInfo() {
		localStorage.removeItem("extraInfo");
	},

	getRefreshToken() {
		return localStorage.getItem(REFRESH_TOKEN_KEY);
	},

	saveRefreshToken(refreshToken) {
		localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
	},

	removeRefreshToken() {
		localStorage.removeItem(REFRESH_TOKEN_KEY);
	},

	removeId() {
		localStorage.removeItem(USER_ID);
	},

	removeAccountId() {
		localStorage.removeItem(ACCOUNT_ID);
	},
};

export { TokenService };
